import React, { FC } from 'react';
import styled from 'styled-components/macro';
import Row from './Row';

export interface InputProps {
  type?: string;
  value?: string | number;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  error?: any;
}

const TextArea: FC<InputProps> = props => {
  const {
    type,
    value,
    onChange,
    placeholder,
    disabled,
    children,
    readOnly,
    ...rest
  } = props;

  return (
    <Row {...rest}>
      <textarea
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
      >

      </textarea>
      {children}
    </Row>
  );
};

export default styled(TextArea)`
  background-color: white;
  border-radius: 7px;
  overflow: hidden;
  border: ${props => props.error !== undefined ? '1px solid red' : 'none'};

  textarea {
    height: 100%;
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
    border: none;
    outline: none;
    flex: 1 1 auto;
    margin: 0 0 0 0;
    padding: 0 0 0 13px;
  }

  textarea::placeholder {
    color: #a5adbb;
  }

  textarea:disabled::placeholder {
    opacity: 0.5;
  }

  textarea:disabled,
  textarea:read-only {
    background-color: #cfcfcf;
  }
`;
